import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { ImageModal } from "app/components/common/ImageModal/ImageModal";
import normalize from "app/utils/normalize";
import React, { memo, useMemo } from "react";
import { Dimensions, StyleSheet } from "react-native";
import { BUBBLE_WIDTH } from "./constants";

const { width } = Dimensions.get("window");

const minBubbleHeight = normalize(150);

const styles = StyleSheet.create({
  messageBubbleChat: {
    backgroundColor: "white",
    width: BUBBLE_WIDTH,
    borderRadius: 8,
    marginTop: 0,
    marginRight: 0,
    margin: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  messageImage: {
    height: minBubbleHeight,
    width: BUBBLE_WIDTH,
    borderRadius: 8,
    margin: 0,
    marginRight: 0,
  },
});

interface Props {
  imageUrl?: string;
}

const ImageMessage = ({ imageUrl }: Props) => {
  const style = useMemo(() => styles.messageImage, []);

  const source = useMemo(() => {
    return {
      uri: imageUrl,
    };
  }, [imageUrl]);

  return (
    <ImageModal
      maxHeight={isWebDesktop ? 300 : null}
      style={style}
      source={source}
      modalImageStyle={styles.messageBubbleChat}
    />
  );
};

export default memo(ImageMessage);
